export default {
    configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '司机',
                value: 'driverName',
                type: 'input',
                unfold: true,
                span: 4
            },
            {
                name: '手机号码',
                value: 'driverPhone',
                type: 'input',
                unfold: true,
                span: 4
            }
        ],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        height: 400,
        leftOperation: true,
        leftWidth: 80,
        selectBtn: true,
        columns: [
            {
                label: '司机',
                prop: 'driverName',
                sort: true,
                width: 120
            },
            {
                label: '手机号码',
                prop: 'driverPhone',
                sort: true,
                width: 150
            },
            {
                label: '身份证号码',
                prop: 'driverIdCard',
                sort: true,
                width: 180
            },
            {
                label: '创建人',
                prop: 'createUserName',
                sort: true,
                width: 120
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true,
                width: 135
            }
        ],
        action: [
            {
                type: 'text',
                label: '删除',
                size: 'small',
                event: 'del'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    searchTotalTitle: []
};
